// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3twmv","notes":"Notes_notes__21FI0"};